import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    targetSelector: String,
    interval: { type: Number, default: 1200 },
  };

  connect() {
    this.checkAndReload();
  }

  checkAndReload() {
    const elementExists = document.querySelector(this.targetSelectorValue);

    if (!elementExists) {
      console.warn(
        `Elemento ${this.targetSelectorValue} não encontrado. Recarregando em ${this.intervalValue}ms...`
      );

      setTimeout(() => {
        // Forçamos o reload com um timestamp para garantir que o cache do browser seja ignorado
        const url = new URL(window.location.href);
        url.searchParams.set("reload", Date.now());

        window.location.href = url.toString();
      }, this.intervalValue);
    } else {
      // Element found
    }
  }
}
